<template>
  <div class="tca" @click.stop>
    <p class="tca-question">{{ copy.question }}</p>

    <div v-if="!isRejecting" class="tca-buttons">
      <button class="tca-btn tca-btn--confirm" :disabled="submitting" @click="confirm">
        {{ submitting ? 'Guardando…' : copy.confirmLabel }}
      </button>
      <button class="tca-btn tca-btn--reject" :disabled="submitting" @click="isRejecting = true">
        {{ copy.rejectLabel }}
      </button>
    </div>

    <div v-else class="tca-reject">
      <label>{{ copy.reasonLabel }}</label>
      <textarea v-model="reason" rows="3" maxlength="2000" :placeholder="copy.reasonPlaceholder"></textarea>
      <small>{{ reason.trim().length }} caracteres (mínimo {{ minLength }})</small>
      <div class="tca-buttons">
        <button class="tca-btn tca-btn--ghost" :disabled="submitting" @click="isRejecting = false">Volver</button>
        <button class="tca-btn tca-btn--reject" :disabled="!isReasonValid || submitting" @click="reject">
          {{ submitting ? 'Enviando…' : 'Enviar' }}
        </button>
      </div>
    </div>

    <p v-if="errorMessage" class="tca-error">{{ errorMessage }}</p>
  </div>
</template>

<script>
import { TICKET_REJECTION_REASON_MIN_LENGTH } from '@/utils/ticketStates';
import { confirmationCopyFor } from './ticketMaterialsConfirmationCopy';

export default {
  name: 'TicketConfirmationActions',
  props: {
    ticket: { type: Object, required: true },
    startRejecting: { type: Boolean, default: false },
  },
  data() {
    return {
      isRejecting: this.startRejecting,
      reason: '',
      submitting: false,
      errorMessage: '',
      minLength: TICKET_REJECTION_REASON_MIN_LENGTH,
    };
  },
  computed: {
    copy() {
      return confirmationCopyFor(this.ticket.topic);
    },
    isReasonValid() {
      return this.reason.trim().length >= this.minLength;
    },
  },
  methods: {
    confirm() {
      this.submit('tickets/confirmResolution', { ticketId: this.ticket.ticket_id });
    },
    reject() {
      this.submit('tickets/rejectResolution', { ticketId: this.ticket.ticket_id, reason: this.reason.trim() });
    },
    async submit(action, payload) {
      this.submitting = true;
      this.errorMessage = '';
      try {
        await this.$store.dispatch(action, payload);
        this.$emit('done');
      } catch (error) {
        this.errorMessage = (error.response && error.response.data && (error.response.data.error
          || (error.response.data.errors && error.response.data.errors.reason && error.response.data.errors.reason[0])))
          || 'No se pudo guardar tu respuesta. Intenta de nuevo.';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.tca {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fff7e6;
  border: 1px solid #f3dcae;
}
.tca-question { margin: 0 0 8px; font-weight: 700; font-size: 13.5px; color: #92400e; }
.tca-buttons { display: flex; gap: 8px; flex-wrap: wrap; }
.tca-btn {
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}
.tca-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.tca-btn--confirm { background: #01662E; color: #fff; }
.tca-btn--reject { background: #b91c1c; color: #fff; }
.tca-btn--ghost { background: #f4f5f4; color: #374151; }
.tca-reject label { display: block; font-weight: 600; font-size: 12.5px; margin-bottom: 4px; }
.tca-reject textarea {
  width: 100%;
  border: 1px solid #d9dedb;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
}
.tca-reject small { display: block; margin: 4px 0 8px; color: #6b7280; }
.tca-error { margin: 8px 0 0; color: #b91c1c; font-size: 12.5px; }
</style>
